const QUIZ_AUDIO_FULL_ID = "quiz-audio-full";
const QUIZ_AUDIO_BRIGHT_ID = "quiz-audio-bright";
const QUIZ_KIT_PROGRESS_ID = "quiz-kit-progress";

function initQuizKit() {
  const fullAudio = document.getElementById(QUIZ_AUDIO_FULL_ID);
  const brightAudio = document.getElementById(QUIZ_AUDIO_BRIGHT_ID);

  if (!fullAudio || !brightAudio) {
    console.warn("Quiz kit audio elements not found");
    return;
  }

  const $progress = jQuery(`<div id="${QUIZ_KIT_PROGRESS_ID}"></div>`);

  const progressInterval = setInterval(function () {
    const $quizContent = jQuery("#quiz-kit-content");

    // Quiz Kit mounts asynchronously. Wait for its content before adapting it.
    if ($quizContent.length === 0) {
      return;
    }

    if ($progress.parent()[0] !== $quizContent[0]) {
      $quizContent.prepend($progress);
    }

    // Slider captions are visually hidden by Quiz Kit on mobile.
    $quizContent[0].querySelectorAll('button[id*="quiz-kit-question-slider"]').forEach((button) => {
      button.setAttribute("aria-label", button.textContent.trim());
    });

    // Current Quiz Kit no longer puts an ID on its numbered heading.
    const stepHeading = Array.from($quizContent[0].querySelectorAll("h3")).find(
      (heading) => /^\d+\s+of\s+\d+$/.test(heading.textContent.trim()),
    );
    const steps = stepHeading?.textContent.trim().match(/^(\d+)\s+of\s+(\d+)$/);
    if (steps && Number(steps[2]) > 0) {
      stepHeading.setAttribute("data-ow-quiz-progress-label", "");
      $progress.css("width", `${(Number(steps[1]) / Number(steps[2])) * 100}%`);
    } else if (!$quizContent[0].querySelector("#quiz-kit-intro-button")) {
      $progress.css("width", "100%");
    } else {
      $progress.css("width", "0%");
    }
    jQuery('[id*="quiz-kit-subscribe-"] > h2[id*="subheading"]')
      .detach()
      .insertAfter('[id*="quiz-kit-subscribe-"] > h1[id*="heading"]');
  }, 500);

  window.addEventListener("pagehide", () => clearInterval(progressInterval), {
    once: true,
  });

  jQuery("body").on(
    "click",
    '[id*="quiz-kit-question-image-text-item-"]:contains("BRIGHT")',
    function () {
      brightAudio.play().catch(() => {});
      fullAudio.pause();
      fullAudio.currentTime = 0;
    },
  );
  jQuery("body").on(
    "click",
    '[id*="quiz-kit-question-image-text-item-"]:contains("FULL")',
    function () {
      fullAudio.play().catch(() => {});
      brightAudio.pause();
      brightAudio.currentTime = 0;
    },
  );
}

initQuizKit();
